module.exports = __webpack_public_path__ + "cancellara-dist/img/image_nearby.8b60205f.jpg";